export const normalizeFlag = (value: string): string => value.trim().toUpperCase()
